app.component("studentChangePasswordModalComponent", {
    templateUrl: _pb + 'student-new/change-password-modal.html',
    controller: StudentChangePasswordModalController,
    controllerAs: 'vm',
    bindings: {
        close: '&',
        dismiss: '&'
    }
});

StudentChangePasswordModalController.$inject = ['AuthService', 'toastr'];

function StudentChangePasswordModalController(AuthService, toastr) {
    var vm = this;
    vm.status = '';
    vm.oldPassword = '';
    vm.newPassword = '';
    vm.repeatNewPassword = '';

    vm.passwordPattern = '^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[\\*\\!\\@\\$\\%\\^\\&\\(\\)\\{\\}\\[\\]\\:\\;\\<\\>\\,\\.\\?\\/\\~\\_\\+\\-\\=\\|]).{8,50}$'

    vm.confirm = function () {
        console.log(vm.resetForm.$valid);
        if (vm.oldPassword && vm.newPassword && vm.repeatNewPassword && vm.resetForm.$valid) {
            if (vm.newPassword === vm.repeatNewPassword) {
                AuthService.changePassword({
                    password: vm.newPassword,
                    oldPassword: vm.oldPassword
                }).then(function () {
                    toastr.success('', 'პაროლი წარმატებით შეიცვალა');
                    vm.close();
                });
            } else {
                vm.status = 'password_not_match';
            }
        } else {
            vm.status = 'fields_not_full';
        }
    };
}
